module.exports = __webpack_public_path__ + "img/icon-categories.2b246da9.svg";